/**
 * @generated SignedSource<<7bc438f967b26160ce0927c4e504bb14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserItem_user$data = {
  readonly firstName: string;
  readonly followerCount: string | null | undefined;
  readonly lastName: string;
  readonly slugId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserFollowingStatus_user" | "UserPrimaryPhoto_user">;
  readonly " $fragmentType": "UserItem_user";
};
export type UserItem_user$key = {
  readonly " $data"?: UserItem_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserItem_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "displayFollowingMessage"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserItem_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "followerCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhoto_user"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "displayFollowingMessage",
          "variableName": "displayFollowingMessage"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserFollowingStatus_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2e1efa2db5263cc6377b8fa9b5cf8e6f";

export default node;
